import type { InputNumberPassThroughOptions } from 'primevue';
import { PassThrough } from '@primevue/core';

export enum InputSize {
  SMALL = 'small',
  LARGE = 'large',
}

export enum InputState {
  SUCCESS = 'success',
  ERROR = 'error',
  DISABLED = 'disabled',
}

export type PassThroughMeridiaInputNumber =
  PassThrough<InputNumberPassThroughOptions> & {
    helper_text?: { class: string };
  };
